import { grey, lightGreen, orange, red } from '@mui/material/colors'
import TinyColor from 'tinycolor2'

const grey850 = TinyColor.mix(grey[800], grey[900], 50).toHexString()

export default {
  PRIMARY: '#5A98B1',
  PRIMARY_DARK: '#01294A',
  PRIMARY_LIGHT: '#F5F9FB',
  SECONDARY: '#4A0E04',
  SECONDARY_DARK: '#270601',
  SECONDARY_LIGHT: '#ECE4D9',
  GREY100: grey[100], // #F5F5F5
  GREY200: grey[200], // #EEEEEE
  GREY300: grey[300], // #E0E0E0
  GREY400: grey[400], // #BDBDBD
  GREY500: grey[500], // #9E9E9E
  GREY850: grey850, // #323232
  RED100: red[100], // #FFCDD2
  ERROR: red[400], // #EF5350
  ALERT: red[700], // #D32F2F
  WARNING: orange[300], // #FFB74D
  SUCCESS: lightGreen[600], // #7CB342
  IMPORTANT: orange[800], // #EF6C00
  LIGHT_TEXT: '#FFFFFF',
  DARK_TEXT: '#000000',
}
